import { IonAlert, useIonRouter } from "@ionic/react";
import { t } from "i18next";
import React, { useContext } from "react";
import { AuthenticatedUserContext } from "../contexts/AuthenticatedUserContext";

export const SignOutAlert = (props: any) => {
  const { showSignOutConfirm, setShowSignOutConfirm } = useContext(AuthenticatedUserContext);
  const router = useIonRouter();

  return (
    <IonAlert
      isOpen={showSignOutConfirm}
      header={t("areYouSure") || ""}
      message={t("signOutConfirm") || ""}
      buttons={[
        {
          text: t("cancel"),
          role: "cancel",
          handler: () => {
            setShowSignOutConfirm(false);
          },
        },
        {
          text: t("signOut"),
          handler: () => {
            setShowSignOutConfirm(false);
            router.push("/sign-out");
          },
        },
      ]}
    />
  );
};
